var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYimbyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "yimbyLogo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4.32c6.405 0 11.614 5.209 11.614 11.614s-5.209 11.614-11.614 11.614c-2.174 0-4.296-0.607-6.132-1.755l-5.336 1.416 1.487-5.346c-1.068-1.788-1.628-3.84-1.628-5.934 0-6.405 5.209-11.614 11.614-11.614zM16.005 0.179c-8.696 0-15.751 7.049-15.751 15.751 0 2.941 0.809 5.694 2.212 8.052l-1.934 7.148 7.148-1.826c2.414 1.506 5.266 2.381 8.325 2.381 8.696 0 15.751-7.049 15.751-15.751s-7.049-15.751-15.751-15.751v-0.005z",
    fill: "#662d91"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.816 15.558c0-0.042 0.005-0.085 0.005-0.127 0-1.812-1.492-3.271-3.313-3.223-1.624 0.047-2.998 1.351-3.12 2.969s1.002 3.073 2.536 3.402c0.042 0.654-0.748 1.901-1.031 2.325-0.033 0.047 0.014 0.113 0.071 0.094 0.833-0.273 4.513-1.685 4.875-5.44h-0.024z",
    fill: "#662d91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.734 15.558c0-0.042 0.005-0.085 0.005-0.127 0-1.812-1.492-3.271-3.313-3.223-1.624 0.047-2.998 1.351-3.12 2.969s1.002 3.073 2.536 3.402c0.042 0.654-0.748 1.901-1.031 2.325-0.033 0.047 0.014 0.113 0.071 0.094 0.833-0.273 4.513-1.685 4.875-5.44h-0.024z",
    fill: "#662d91"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYimbyLogo);
export default __webpack_public_path__ + "static/media/yimbyLogo.2629b9e7592ac36ad9122e5ceb1897c2.svg";
export { ForwardRef as ReactComponent };